import React, { useState } from 'react';
import Form from '../../molecules/Form/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import { StyledDeleteStep } from './CreateCompaign.styles';
import { useForm } from '../../molecules/Form';
import campaignService from '../../../services/campaignService';
import Toast from '../../molecules/Toast';

const DeleteStep = ({ onClose, handleDeleteStep }) => {
  const [form] = useForm();

  return (
    <StyledDeleteStep>
      <strong className="heading">Delete Sequence</strong>
      <span className="text">
        Deleting this sequence will permanently remove it’s data from everywhere. Are you sure you want to continue?
        Type DELETE below to confirm.
      </span>
      <Form form={form} onSubmit={e => handleDeleteStep(e)}>
        <Form.Item
          type="text"
          name="delete"
          placeholder="Type DELETE"
          rules={[
            { required: true, message: 'Please type DELETE' },
            {
              transform: value => {
                if (value !== 'DELETE') {
                  return true;
                }
              },
              message: 'You must type DELETE exactly',
            },
          ]}>
          <Field />
        </Form.Item>

        <div className="btn-holder">
          <Button variant="secondary" width="150px" onClick={onClose}>
            Cancel
          </Button>
          <Button width="150px" type="submit">
            Confirm
          </Button>
        </div>
      </Form>
    </StyledDeleteStep>
  );
};

export default DeleteStep;
